import React, { useEffect, useState } from "react";
import { PiUser } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import PopupMex from "../../Components/SavePopup";
import TicketModal from "./TicketModal";
import { TbGalaxy } from "react-icons/tb";

const OpenTicket = () => {
    const { ticket_id } = useParams()
    const user_id = sessionStorage.getItem("user_id");
    const [records, setRecords] = useState({});
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [message, setMessage] = useState("");
    const [popupType, setPopupType] = useState("success")
    const [popupActive, setPopupActive] = useState(false)
    const [popupMex, setPopupMex] = useState("")
    const [caseType, selectCaseType] = useState("");
    const [openTicketModal, setOpenTicketModal] = useState(false)

    const goBack = () => {
        navigate("/control_panel/support")
    }

    useEffect(() => {
        if (user_id && ticket_id) {
            fetchRecords();
        } else {
            setError(true);
            setLoading(false);
        }
    }, [user_id]);

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_ticket", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, ticket_id }),
            });
            setLoading(false)
            if (response.ok) {
                const result = await response.json();
                const ticketsData = result.tickets || {};


                setRecords(ticketsData);
                selectCaseType(ticketsData.case_type)
            } else {
                setError(true);
            }
        } catch (err) {
            setLoading(false)
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/new_ticket", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id,
                    ticket_id,
                    caseType,
                    message,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to submit ticket.");
            }

            const result = await response.json();

            setPopupType("success")
            setPopupActive(true)
            setPopupMex("")
            setMessage("");
            fetchRecords()
            setLoading(false)
        } catch (error) {
            setPopupType("error")
            setPopupActive(true)
            setPopupMex("Error submitting ticket")
            setLoading(false)
        }
    };

    const handlePopupClose = () => {
        setPopupActive(false);
    };

    return (
        <div className="middle_cont_main">
            <PopupMex
                active={popupActive} type={popupType} message={popupMex}
                onClose={handlePopupClose}
            />
             <p className="new_section_main_view_title"> <i
                className="fa-solid fa-chevron-left"
                onClick={goBack}
            ></i>{" "} Ticket {ticket_id}</p>
            <p className="new_section_main_view_subtitle">Ticket progress and communication</p>
            <div className="ticket_details">
                {records.case_type == "db" ? (
                    <p>Database - Database issues</p>
                ) : records.case_type == "collection" ? (
                    <p>Collection - Collection issues</p>

                ) : records.case_type == "backup" ? (
                    <p>Backup DR - Disaster recovery issues</p>

                ) : records.case_type == "apis" ? (
                    <p>Access - APIs and Keys</p>

                ) : records.case_type == "billing" ? (
                    <p>Billing - Billing and payments</p>

                ) : (
                    <p>General - General issues</p>
                )
                }
                {records.status === "open" ? (
                    <button className="close_ticket_btn" onClick={() => setOpenTicketModal(true)}>Close ticket</button>
                ) : (
                    <p>Closed</p>
                )}
            </div>
            <div className="ticket_body">
                {records.messages
                    ?.slice() // Create a shallow copy to avoid mutating the original
                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)) // Sort by timestamp descending
                    .map((msg, index) => (
                        <div className="ticket_message" key={index}>
                            <div className="ticket_user">
                                {user_id === msg.user_id ? (
                                    <p><PiUser /> Me</p>
                                ) : (
                                    <p><TbGalaxy/></p>
                                )}
                            </div>
                            <div className="ticket_mex">
                                <p>{msg.message}</p>
                                <p className="ticket_timestamp">{new Date(msg.timestamp).toLocaleString()}</p>
                            </div>
                        </div>
                    ))}

            </div>
            {records.status == "open" && (
                <>
                    <p className="ticket_micro_titles">Send a new message</p>
                    <textarea
                        className="ticket_input_open"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Write a new message..."
                    ></textarea>
                    <div className="middle_container_btn_cont">
                        <button className="support_btn" onClick={handleSubmit}>
                            {loading ? (
                                <Spinner loading={loading} />
                            ) :
                                <>Submit new message</>
                            }

                        </button>
                    </div>
                </>
            )}

            <TicketModal
                show={openTicketModal}
                handleClose={() => setOpenTicketModal(false)}
                recordObject={records}
                fetchRecords={fetchRecords}
            />

        </div>
    )
}

export default OpenTicket